<script setup lang="ts">
import GbButton from '@/components/GbButton.vue'
import type { StudentCharacteristic } from './sdi_types'

withDefaults(defineProps<{
  characteristics?: StudentCharacteristic[]
}>(), {
  characteristics: () => [],
})

const emit = defineEmits<{
  reset: []
}>()
</script>

<template>
  <div class="mt-4 w-full text-md leading-10">
    <div class="flex">
      <span class="mr-3 shrink-0">Student information:</span>
      <div class="flex-1">
        <span
          v-for="characteristic in characteristics"
          :key="characteristic.id"
          class="mb-2 mr-2 inline-block rounded-md bg-blue-200/50 px-6 py-2 leading-5"
          data-testid="characteristic-summary-item"
        >
          {{ characteristic.name }}
        </span>
      </div>
    </div>
    <GbButton gb-theme="bluePrimary" size="small" class="mt-2" @click="emit('reset')">Start Over</GbButton>
  </div>
</template>
